import * as React from 'react';

import * as styles from '../styles.css';

export const CardLayout: React.FC<React.PropsWithChildren> = ({ children }) => {
  return <div className={styles['layout']}>{children}</div>;
};
